import React from 'react'

import { Button, Text, theme } from '@hhgtech/hhg-components'
import {
  SectionContainerStyled,
  StyledContainer,
} from 'components/atoms/container/index.styled'
import { ICommunities, ICommunity } from 'interfaces/categories.interface'
import { useIntl } from 'react-intl'
import styled from 'styled-components'

const CommunityStyled = styled.section`
  border-radius: 16px;
  box-shadow: 0px 1px 3px rgb(0 0 0 / 8%);
  header {
    font-size: 16px;
  }
  .banner {
    position: relative;
  }
  .sub-icon {
    position: absolute;
    left: 16px;
    bottom: -8px;
    width: 40px;
    height: 40px;
  }
  .content {
    line-height: 40px;
    padding: 24px 16px;
    .analytics {
      color: ${(props) => props.theme.mbColors.midGray};
      & > span {
        padding-right: 4px;
      }
    }
  }
  .btn-join {
    border-radius: 16px;
    border-color: ${(props) => props.theme.mbColors.pink} !important;
    color: ${(props) => props.theme.mbColors.pink} !important;
    &,
    &:hover,
    &:active,
    &:focus {
      background-color: ${(props) => props.theme.colors.white} !important;
    }
  }
`

const Community = ({ title, guestTitle, memberTitle }: ICommunity) => {
  const { formatMessage: f } = useIntl()
  return (
    <CommunityStyled className="community">
      <div className="banner">
        <img loading="lazy" className="main" src="/images/bmrThumbnail.png" />
        <img loading="lazy" className="sub-icon" src="/images/bookDoctor.svg" />
      </div>
      <div className="content">
        <header>{title || guestTitle}</header>
        <p className="analytics">
          <span>{memberTitle}</span>
        </p>
        <Button color="secondary" size="lg" isBlock className="btn-join">
          {f({ id: 'bmi.joinNow' })}
        </Button>
      </div>
    </CommunityStyled>
  )
}

const CommunitiesStyled = styled(StyledContainer)`
  .community {
    margin-bottom: 12px;
  }
  .more {
    cursor: pointer;
  }
`

const Communities = ({ communities }: ICommunities) => {
  const { formatMessage: f } = useIntl()
  const [renderNumber, setRenderNumber] = React.useState<number>(1)
  const [items] = React.useState<ICommunity[]>(
    Array.isArray(communities)
      ? (communities as ICommunity[]) || []
      : [communities],
  )

  return (
    <CommunitiesStyled className="communities">
      <header>
        {f({ id: 'community' })}
        {renderNumber === 1 && (
          <div className="more" onClick={() => setRenderNumber(items.length)}>
            <Text size="n1" color={theme.mbColors.pink}>
              {f({
                id: 'home.seeMore',
                defaultMessage: 'View All',
              })}
            </Text>
          </div>
        )}
      </header>
      <SectionContainerStyled className="communities-container">
        {items.slice(0, renderNumber).map((community: ICommunity) => (
          <Community key={community.title} {...community} />
        ))}
      </SectionContainerStyled>
    </CommunitiesStyled>
  )
}

export default Communities
